import React, { useState } from 'react';
import ArrowExpandFilled from '@uber/base-icons/arrow-expand-filled';
import { styled } from 'baseui';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { Modal, ModalBody, SIZE as ModalSIZE } from 'baseui/modal';
import VideoComponent from './video-component';
const Container = styled('div', {
  position: 'relative'
});
const VideoExpandButtonContainer = styled('div', {
  position: 'absolute',
  top: '5px',
  left: '5px'
});
const expandedVideoModelOverrides = {
  Root: {
    style: {
      // default is 'fixed' which causes modal to overflow parent if consumer is using layout system like f7-ux
      position: 'absolute'
    }
  },
  DialogContainer: {
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    }
  },
  Dialog: {
    style: {
      width: '100%',
      height: '100%',
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0
    }
  }
};
const Video = ({
  src,
  videoPlaybackSpeed
}: {
  src: string;
  videoPlaybackSpeed?: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <Container>
      <VideoComponent src={src} videoPlaybackSpeed={videoPlaybackSpeed} />

      <VideoExpandButtonContainer>
        <Button kind={KIND.secondary} shape={SHAPE.circle} size={SIZE.mini} onClick={() => setIsOpen(true)}>
          <ArrowExpandFilled title="Expand Video" />
        </Button>
      </VideoExpandButtonContainer>
      <Modal focusLock={false} isOpen={isOpen} onClose={() => setIsOpen(false)} size={ModalSIZE.auto} overrides={expandedVideoModelOverrides} closeable>
        <ModalBody>
          <div style={{
          display: 'flex',
          marginTop: '50px'
        }}>
            <VideoComponent src={src} videoPlaybackSpeed={videoPlaybackSpeed} />
          </div>
        </ModalBody>
      </Modal>
    </Container>;
};
export default Video;